import { useMutation } from 'react-query';
import deleteRoomImage from '../requests/deleteRoomImage';

const useDeleteRoomImageMutation = (options) =>
  useMutation(
    ({ imageId, room }) => deleteRoomImage(imageId, room),
    options
  );

export default useDeleteRoomImageMutation;
